const STYLE = `
@media (prefers-reduced-motion: no-preference) {
  .gcm-ghost { animation: gcm-bob 4.5s ease-in-out infinite; }
  .gcm-blink { animation: gcm-blink 5s infinite; transform-origin: center; transform-box: fill-box; }
  .gcm-tv { animation: gcm-flicker 2.6s steps(6) infinite; }
  .gcm-glow { animation: gcm-pulse 3.2s ease-in-out infinite; }
  .gcm-win { animation: gcm-pulse 6s ease-in-out infinite; }
  .gcm-bat { animation: gcm-fly linear infinite; }
  .gcm-fog { animation: gcm-drift 14s ease-in-out infinite alternate; }
  .gcm-smoke { animation: gcm-rise 5s ease-in-out infinite; }
}
@keyframes gcm-bob { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-4px); } }
@keyframes gcm-blink { 0%, 92%, 100% { transform: scaleY(1); } 95% { transform: scaleY(0.1); } }
@keyframes gcm-flicker { 0% { opacity: 0.85; } 30% { opacity: 0.55; } 60% { opacity: 0.95; } 100% { opacity: 0.7; } }
@keyframes gcm-pulse { 0%, 100% { opacity: 0.55; } 50% { opacity: 1; } }
@keyframes gcm-fly { 0% { transform: translate(-60px, var(--y)); } 100% { transform: translate(660px, calc(var(--y) - 30px)); } }
@keyframes gcm-drift { 0% { transform: translateX(-18px); } 100% { transform: translateX(18px); } }
@keyframes gcm-rise { 0% { opacity: 0; transform: translateY(6px); } 40% { opacity: 0.6; } 100% { opacity: 0; transform: translateY(-14px); } }
`;

const WING_WINDOWS = [
  [92, 345],
  [140, 345],
  [442, 345],
  [490, 345],
  [460, 420],
];

const FENCE = Array.from({ length: 25 }, (_, i) => i * 25 + 6);

/** Wireframe haunted mansion: a ghost on the couch watching TV through the parlor window. */
export default function HauntedMansion({ className = '' }) {
  return (
    <svg
      viewBox="0 0 600 560"
      className={className}
      fill="none"
      stroke="url(#gcmStroke)"
      strokeWidth="1.4"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <style>{STYLE}</style>
      <defs>
        <linearGradient id="gcmStroke" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="var(--primary)" />
          <stop offset="1" stopColor="var(--highlight)" />
        </linearGradient>
        <radialGradient id="gcmTvGlow" cx="0.5" cy="0.5" r="0.5">
          <stop offset="0" stopColor="var(--primary)" stopOpacity="0.55" />
          <stop offset="0.5" stopColor="var(--primary)" stopOpacity="0.18" />
          <stop offset="1" stopColor="var(--primary)" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="gcmMoonGlow" cx="0.5" cy="0.5" r="0.5">
          <stop offset="0" stopColor="var(--highlight)" stopOpacity="0.35" />
          <stop offset="1" stopColor="var(--highlight)" stopOpacity="0" />
        </radialGradient>
        <radialGradient id="gcmWinGlow" cx="0.5" cy="0.5" r="0.5">
          <stop offset="0" stopColor="var(--primary)" stopOpacity="0.5" />
          <stop offset="1" stopColor="var(--primary)" stopOpacity="0.05" />
        </radialGradient>
        <clipPath id="gcmParlor">
          <path d="M215 470 V365 Q300 300 385 365 V470 Z" />
        </clipPath>
      </defs>

      <circle cx="505" cy="85" r="80" fill="url(#gcmMoonGlow)" stroke="none" className="gcm-glow" />
      <circle cx="505" cy="85" r="34" />
      <path d="M490 70 a6 6 0 1 0 0.1 0" opacity=".4" />
      <path d="M515 98 a4 4 0 1 0 0.1 0" opacity=".4" />

      {[0, 1, 2].map((i) => (
        <g
          key={i}
          className="gcm-bat"
          style={{ animationDelay: `${i * -4.3}s`, animationDuration: `${12 + i * 3}s`, '--y': `${70 + i * 45}px` }}
        >
          <path
            d="M0 0 q6 -7 12 -1 q2 -4 4 0 q2 -4 4 0 q6 -6 12 1 q-8 0 -12 6 q-2 -3 -4 -3 q-2 0 -4 3 q-4 -6 -12 -6z"
            strokeWidth="1.1"
          />
        </g>
      ))}

      <g opacity=".75">
        <path d="M40 500 V380 M40 430 L18 400 M40 410 L66 372 M40 380 L28 350 M40 380 L52 345 M66 372 L80 366 M18 400 L8 396" />
      </g>

      <g fill="var(--background)">
        <path d="M70 500 V320 H180 V500 Z" />
        <path d="M60 320 L120 262 L180 320 Z" />
        <path d="M420 500 V320 H530 V500 Z" />
        <path d="M420 320 L480 262 L540 320 Z" />
        <path d="M378 225 V168 H402 V225 Z" />
        <path d="M374 168 H406" />
        <path d="M170 500 V250 H430 V500 Z" />
        <path d="M156 252 L300 150 L444 252 Z" />
        <path d="M268 250 V110 H332 V250 Z" />
        <path d="M260 112 L300 38 L340 112 Z" />
      </g>
      <path d="M300 38 V20 M294 26 H306" />

      <g className="gcm-smoke">
        <path d="M390 160 q-10 -14 2 -26 q12 -12 0 -26" strokeDasharray="3 6" />
      </g>

      <path d="M200 228 H400 M232 205 H368" opacity=".22" />
      <path d="M90 300 H150 M450 300 H510" opacity=".22" />

      <path d="M288 200 V165 Q300 148 312 165 V200 Z" fill="url(#gcmWinGlow)" className="gcm-win" />
      <path d="M300 152 V200 M288 180 H312" opacity=".6" />
      <circle cx="300" cy="130" r="9" opacity=".7" />

      {[195, 375].map((x, i) => (
        <g key={x}>
          <path
            d={`M${x} 310 V278 Q${x + 15} 262 ${x + 30} 278 V310 Z`}
            fill="url(#gcmWinGlow)"
            className="gcm-win"
            style={{ animationDelay: `${i * -2}s` }}
          />
          <path d={`M${x + 15} 268 V310 M${x} 292 H${x + 30}`} opacity=".6" />
        </g>
      ))}

      {WING_WINDOWS.map(([x, y], i) => (
        <g key={`${x}-${y}`}>
          <rect
            x={x}
            y={y}
            width="22"
            height="32"
            fill={i === 2 ? 'url(#gcmWinGlow)' : 'var(--background)'}
            className={i === 2 ? 'gcm-win' : undefined}
          />
          <path d={`M${x + 11} ${y} V${y + 32} M${x} ${y + 16} H${x + 22}`} opacity=".55" />
        </g>
      ))}

      <circle cx="120" cy="298" r="7" />
      <circle cx="480" cy="298" r="7" fill="url(#gcmWinGlow)" className="gcm-win" />

      <path d="M102 500 V455 Q120 432 138 455 V500" />
      <circle cx="132" cy="478" r="1.6" fill="var(--primary)" stroke="none" />
      <path d="M92 500 H148" />

      <path d="M215 470 V365 Q300 300 385 365 V470 Z" fill="var(--card)" />
      <g clipPath="url(#gcmParlor)">
        <ellipse cx="340" cy="405" rx="110" ry="80" fill="url(#gcmTvGlow)" stroke="none" className="gcm-glow" />
        <rect x="236" y="362" width="26" height="20" opacity=".35" />
        <g>
          <rect x="318" y="382" width="52" height="38" rx="5" />
          <rect x="323" y="387" width="42" height="28" rx="2" fill="var(--primary)" stroke="none" className="gcm-tv" />
          <g stroke="var(--background)" strokeWidth="1" opacity=".5">
            <path d="M325 393 H362 M325 399 H358 M325 405 H363 M325 411 H355" />
          </g>
          <path d="M334 382 L326 368 M354 382 L362 368" />
          <path d="M326 420 L322 432 M362 420 L366 432" />
          <path d="M312 432 H376 V448 H312 Z" />
        </g>
        <path d="M228 470 V440 Q228 430 238 430 H292 Q302 430 302 440 V470" />
        <path d="M222 470 V448 Q222 442 230 442 M308 470 V448 Q308 442 300 442" />
        <g className="gcm-ghost">
          <path
            d="M246 438 V412 a21 21 0 0 1 42 0 V438 l-6 -5 -6 5 -6 -5 -6 5 -6 -5 -6 5 z"
            fill="var(--primary)"
            fillOpacity="0.16"
            stroke="var(--primary)"
          />
          <ellipse cx="274" cy="410" rx="2.6" ry="4.2" fill="var(--background)" stroke="none" className="gcm-blink" />
          <ellipse cx="284" cy="410" rx="2.6" ry="4.2" fill="var(--background)" stroke="none" className="gcm-blink" />
          <ellipse cx="280" cy="423" rx="2.2" ry="3" fill="var(--background)" stroke="none" />
          <path d="M252 436 l3 -12 h11 l3 12 z" stroke="var(--highlight)" fill="var(--background)" />
          <path d="M255 424 q2 -5 5 -1 q3 -5 6 0" stroke="var(--foreground)" opacity=".8" />
        </g>
        <path d="M215 470 H385" />
      </g>
      <path d="M215 470 V365 Q300 300 385 365 V470 Z" />
      <path d="M300 333 V340" opacity=".6" />
      <path d="M208 472 H392" />

      <path d="M0 500 H600" />
      <path d="M260 500 v6 h80 v-6 M250 506 v6 h100 v-6" opacity=".55" />

      <g opacity=".6">
        <path d="M0 528 H600 M0 540 H600" />
        {FENCE.map((x) => (
          <path key={x} d={`M${x} 548 V516 l-3 4 M${x} 516 l3 4`} />
        ))}
      </g>

      <ellipse
        cx="300"
        cy="512"
        rx="320"
        ry="26"
        fill="var(--primary)"
        fillOpacity="0.06"
        stroke="none"
        className="gcm-fog"
      />
    </svg>
  );
}
